import { useEffect, useRef, useState } from 'react'

const BOTTOM_MARGIN = 16

// Computes a max-height for a sticky panel so it never overflows the viewport
// as the page scrolls. Returns { ref, maxHeight } — attach `ref` to the panel
// root and apply `maxHeight` to its style.
export default function usePanelMaxHeight () {
  const ref = useRef(null)
  const [maxHeight, setMaxHeight] = useState(null)

  useEffect(() => {
    let rafId = null

    const recompute = () => {
      if (!ref.current) return
      const { top } = ref.current.getBoundingClientRect()
      setMaxHeight(`${window.innerHeight - top - BOTTOM_MARGIN}px`)
    }

    const schedule = () => {
      if (rafId) cancelAnimationFrame(rafId)
      rafId = requestAnimationFrame(recompute)
    }

    recompute()
    window.addEventListener('scroll', schedule, true)
    window.addEventListener('resize', schedule)
    return () => {
      if (rafId) cancelAnimationFrame(rafId)
      window.removeEventListener('scroll', schedule, true)
      window.removeEventListener('resize', schedule)
    }
  }, [])

  return { ref, maxHeight }
}
